import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { BonusStatusApiService, MyAccountActions } from '@my-account/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { AuthActions } from '@spartacus/core';
import { BonusSystemFeatureAvailableService } from '@user/feature';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class BonusStatusEffects {
  loadBonusStatus$: Observable<MyAccountActions.LoadBonusStatusFail | MyAccountActions.LoadBonusStatusSuccess> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(MyAccountActions.LOAD_BONUS_STATUS),
        map((action: MyAccountActions.LoadBonusStatus) => action),
        concatLatestFrom(() => [this.bonusSystemFeatureAvailableService.isFeatureAvailable()]),
        switchMap(([, isFeatureAvailable]) => {
          if (isFeatureAvailable) {
            return this.bonusStatusApiService.loadBonusStatus().pipe(
              map((bonusStatus) => new MyAccountActions.LoadBonusStatusSuccess(bonusStatus)),
              catchError(() => of(new MyAccountActions.LoadBonusStatusFail())),
            );
          } else {
            return of(new MyAccountActions.LoadBonusStatusFail());
          }
        }),
      ),
    );

  loadBonusStatusOnCityChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(() => new MyAccountActions.LoadBonusStatus()),
    ),
  );

  resetBonusStatusOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      switchMap(() =>
        this.bonusSystemFeatureAvailableService.isFeatureAvailable().pipe(
          filter(Boolean),
          map(() => new MyAccountActions.LoadBonusStatusReset()),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private bonusSystemFeatureAvailableService: BonusSystemFeatureAvailableService,
    private bonusStatusApiService: BonusStatusApiService,
  ) {}
}
